<form id="pick" [formGroup]="registroForm" *ngIf="registroForm">
  <div id="campo" *ngIf="parametros_pick">
    <div
      [ngClass]="{ 'vertical-container': direction === 'vertical', 'horizontal-container': direction === 'horizontal' }" class="grid">
      <div *ngFor="let opcion of parametros_pick.opciones; let i = index">
        <p-checkbox [disabled]="pick_bloqueado" formControlName="pickSeleccionado" [value]="opcion" [inputId]="'pickSeleccionado' + i" (onChange)="onCheckboxChange(opcion)"/>
        <label [for]="'pickSeleccionado' + i" [style]="{'margin-left': '1rem'}" [ngStyle]="{ 'font-size': font_size_opciones || 'inherit' }">{{ opcion }}</label>
      </div>
    </div>
  </div>
</form>
